<template>
  <div>
    <vx-card>
      <div class="flex h-12 mt-1 fit-height">
        <div class="w-full ml-2 fit-height">
          <div class="vx-row mb-6">
            <div class="vx-col w-full">
              <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                <label for="" class="vs-input--label">Quem somos</label>
                <div class="vs-con-input">
                  <textarea
                  v-model="quemSomos.texto"
                  type="text"
                  class="vs-inputx vs-input--input normal"
                  style="border: 1px solid rgba(0, 0, 0, 0.2);"
                  v-on:keyup="textAreaAdjust"
                  ></textarea>

                </div>
              </div>
            </div>
          </div>

          <vs-table :data="quemSomos">


              <template slot="thead">
                <vs-th>Item</vs-th>
                <vs-th>Quantidade</vs-th>
              </template>

              <template>
                <vs-tr>
                  <vs-td>
                    Unidades Vendidas
                  </vs-td>
                  <vs-td>
                    <div class="vs-con-input">
                      <vs-input-number
                        v-model="quemSomos.unidades_vendidas"
                        required
                      />
                    </div>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>
                    Unidades em Desenvolvimento
                  </vs-td>
                  <vs-td>
                    <div class="vs-con-input">
                      <vs-input-number
                        v-model="quemSomos.em_desenvolvimento"
                        required
                      />
                    </div>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>
                    Unidades em Construção
                  </vs-td>
                  <vs-td>
                    <div class="vs-con-input">
                      <vs-input-number
                        v-model="quemSomos.em_construcao"
                        required
                      />
                    </div>
                  </vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td>
                    Unidades em Lançamento
                  </vs-td>
                  <vs-td>
                    <div class="vs-con-input">
                      <vs-input-number
                        v-model="quemSomos.em_lancamento"
                        required
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>

          <form v-on:submit.prevent="salvar" id="formulario">
            <!-- <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary">
                  <label for="" class="vs-input--label">Texto inicial</label>
                  <div class="vs-con-input">
                    <textarea
                      v-model="quemSomos.texto"
                      type="text"
                      class="vs-inputx vs-input--input normal hasIcon"
                      style="border: 1px solid rgba(0, 0, 0, 0.2);"
                      required
                      v-on:keyup="textAreaAdjust"
                    ></textarea>
                    <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-phone null icon-no-border"></i>
                  </div>
                </div>
              </div>
            </div> -->

          <br />
          <div class="vx-row">
            <div class="vx-col w-full">
              <button class="vs-component vs-button mr-3 mb-2 vs-button-primary vs-button-filled" type="submit">Salvar</button>
            </div>
          </div>
        </form>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      quemSomos: {
        texto: '',
        unidades_vendidas: 0,
        em_desenvolvimento: 0,
        em_construcao: 0,
        em_lancamento: 0
      },
    }
  },
  methods: {
    textAreaAdjust: function(o) {
      o.target.style.height = (o.target.scrollHeight > o.target.clientHeight) ? (o.target.scrollHeight)+"px" : "53.29px";
    },
    salvar: function() {
      fetch(this.$API_URL + "/quem-somos", {
        method: "POST",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(this.quemSomos)
      })
      .then(response => response.json())
      .then(json => {
        if (json.status == 'success') {
          this.$vs.notify({
          title:'Sucesso!',
          text:'Salvo com sucesso.',
          color:'primary'})
        } else {
          this.$vs.notify({
          title:'Erro!',
          text:'Ocorreu um erro ao salvar.',
          color:'danger'})
        }
      })
    },
    getQuemSomos: function() {
      fetch(this.$API_URL + "/quem-somos/dados", {
        method: "GET",
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        })
      })
      .then(response => response.json())
      .then(json => {
        //console.log(json)
        this.quemSomos = json.data[0]
      });
    }
  },
  mounted() {
    this.getQuemSomos();
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
